var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artwork, message, name, representative, user) {
buf.push("<header class=\"scontact-header\"><h1 class=\"scontact-headline\">Send message to Artsy</h1><div class=\"scontact-details\">");
if ( representative)
{
buf.push("<div class=\"scontact-description vam-outer\"><div class=\"vam-cell\">");
if ( name = representative.related().owner.get('name'))
{
buf.push("" + (jade.escape((jade_interp = representative.related().owner.get('name')) == null ? '' : jade_interp)) + ", an Artsy Specialist,");
}
else
{
buf.push("An Artsy Specialist");
}
buf.push(" is available to answer your questions and help you collect through Artsy.</div><div class=\"vam-cell\"><img" + (jade.attr("src", representative.iconImageUrl(), true, true)) + (jade.attr("alt", representative.get('name'), true, true)) + " width=\"60\" height=\"60\"></div></div>");
}
if ( user && user.get('name') && user.get('email'))
{
buf.push("<p class=\"scontact-from\">From: " + (jade.escape((jade_interp = user.get('name')) == null ? '' : jade_interp)) + " <span>(" + (jade.escape((jade_interp = user.get('email')) == null ? '' : jade_interp)) + ")</span></p>");
}
buf.push("</div></header><form class=\"scontact-form stacked-form\"><div class=\"scontact-errors js-form-errors\"></div>");
if ( artwork)
{
buf.push("<input type=\"hidden\" name=\"artwork\"" + (jade.attr("value", artwork.id, true, true)) + ">");
}
buf.push("<label for=\"message\" class=\"avant-garde-form-label\">Your message</label><textarea id=\"message\" name=\"message\" placeholder=\"Leave your comments\" rows=\"7\" autofocus required class=\"bordered-input\">" + (jade.escape(null == (jade_interp = message) ? "" : jade_interp)) + "</textarea>");
if ( user && user.get('name') && user.get('email'))
{
buf.push("<input type=\"hidden\" name=\"name\"" + (jade.attr("value", user.get('name'), true, true)) + "><input type=\"hidden\" name=\"email\"" + (jade.attr("value", user.get('email'), true, true)) + ">");
}
else
{
buf.push("<input type=\"text\" name=\"name\" placeholder=\"Your full name\"" + (jade.attr("val", user ? user.get('name') : undefined, true, true)) + " required class=\"bordered-input\"><input type=\"email\" name=\"email\" placeholder=\"Your email address\"" + (jade.attr("val", user ? user.get('email') : undefined, true, true)) + " required class=\"bordered-input\"><p class=\"scontact-privacy\">By clicking send, you accept our\n<a class='fine-faux-underline' href='/privacy' target='_blank'>Privacy Policy</a>.</p>");
}
buf.push("<button class=\"avant-garde-button-black\">Send</button></form>");}.call(this,"artwork" in locals_for_with?locals_for_with.artwork:typeof artwork!=="undefined"?artwork:undefined,"message" in locals_for_with?locals_for_with.message:typeof message!=="undefined"?message:undefined,"name" in locals_for_with?locals_for_with.name:typeof name!=="undefined"?name:undefined,"representative" in locals_for_with?locals_for_with.representative:typeof representative!=="undefined"?representative:undefined,"user" in locals_for_with?locals_for_with.user:typeof user!=="undefined"?user:undefined));;return buf.join("");
};
module.exports = template;